import { StorageService } from './../../../services/storage/storage.service';
import { EditSidenavService } from './../edit-sidenav/edit-sidenav.service';
import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  ChangeDetectorRef,
  ViewChild,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SetComponentsService } from '../../../services/edit/set-components.service';
import { SharedService } from '../../../services/shared/shared.service';
import { MediumEditorSharedComponent } from './../edit-sidenav/medium-editor-shared/medium-editor-shared.component';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'edit-c-text',
  templateUrl: './edit-c-text.component.html',
  styleUrls: ['./edit-c-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditCTextComponent
  extends SidenavContent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @ViewChild('medEditorTB') medEditorTB: MediumEditorSharedComponent;
  @Input() textBlock: any;
  @Input() template: any;
  @Input() rowType: any;
  @Input() rowArray: any;
  @Input() compArray: any;
  @Input() edit: boolean;
  @Input() zeroResults: any = false;

  color: any = '#454545';
  background: any;
  text = '';
  flushed: any;
  zeroResultsMessage =
    'Select text to format. If you create a hyperlink, it should be a fully qualified URL with http / https';
  //  --- plugin Medium Editor used ---
  //  https://www.npmjs.com/package/medium-editor
  //  http://yabwe.github.io/medium-editor/
  //  https://github.com/yabwe/medium-editor/blob/master/OPTIONS.md

  private _typeOf: any = 'text';
  private _className: any = 'height-250';
  private _textIndent: any;
  private _temp: any;
  private _zeroResultsData: any;
  private _destroyed$ = new Subject<void>();

  constructor(
    private _cd: ChangeDetectorRef,
    private _layoutService: LayoutService,
    private _editService: SetComponentsService,
    private _editSidenavService: EditSidenavService,
    private _sharedService: SharedService,
    private _storageService: StorageService,
  ) {
    super(_layoutService);
  }

  ngOnInit() {
    if (this.zeroResults) {
      setTimeout(() => {
        this._getZeroResultsTextBlock();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.zeroResults) {
        this.zeroResults = changes.zeroResults.currentValue;
      } else {
        this.zeroResults = false;
      }
    }
    if (!this.zeroResults) {
      // assign Input() temp to local variable for data binding.
      this._temp = this.template;
      // check Input() edit to pass in variables or set new variables.
      if (this.edit) {
        this.setRowType();
        this.setFormVariables();
      } else {
        this.setNewVariablesToDefault();
      }
    }
  }

  ngAfterViewInit() {
    this._cd.detectChanges();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  updateTEXT(txtBlk): void {
    const result = {
      typeOf: 'text',
      className: this._className,
      color: this.color,
      background: this.background,
      text: this.medEditorTB.getInnerText(),
      textIndent: this._textIndent,
      flushed: this.flushed,
    };
    console.log('result');
    console.log(result);
    this._editService.setTEXT(result, this.rowType, this._temp, this.rowArray, this.compArray);
  }

  submitTEXT(txtBlk): void {
    const result = {
      typeOf: 'text',
      className: this._className,
      color: this.color,
      background: this.background,
      text: this.medEditorTB.getInnerText(),
      textIndent: this._textIndent,
      flushed: this.flushed,
    };
    this._editService.setTEXT(result, this.rowType, this._temp, this.rowArray, this.compArray);
    this.closeNav();
  }

  submitTEXT4zr(): void {
    const result = {
      cid: this._storageService.getCid(),
      lid: this._storageService.getLid(),
      className: this._className,
      color: this.color,
      background: this.background,
      text: this.medEditorTB.getInnerText(),
    };
    this._editSidenavService.saveZeroResultsTextBlock(result).subscribe((response) => {
      if (response.status === '201 created') {
        this._zeroResultsData = response.data;
        this._sharedService.openSnackBar(response.message, 'ok');
        if (this._zeroResultsData[0].results.length > 0) {
          const results = this._zeroResultsData[0].results[0];
          this.text = results.text;
          this.color = results.color;
          this.background = results.background;
          this._className = results.className;
        }
      }
    });
  }

  private _getZeroResultsTextBlock(): void {
    this._editSidenavService.zeroResultsTextBlock$
      .pipe(takeUntil(this._destroyed$))
      .subscribe((result) => {
        this.text = result.text;
        this.color = result.color;
        this.background = result.background;
        this._className = result.className;
      });
  }

  getTXTStyles(): object {
    return { 'background-color': this.background, color: this.color };
  }

  // If they choose the Edit Component Link.
  setRowType(): void {
    // Just in case values are null, pre-populate.
    switch (this.rowType) {
      case 'col-2':
        //this.TwoColumns=true;
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-21':
        //this.TwoColumns=true;
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-2-1-2':
        //this.TwoColumns=true;
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-2-1-3':
        //this.TwoColumns=true;
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-2-2-1':
        //this.TwoColumns=true;
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-2-3-1':
        //this.TwoColumns=true;
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-31':
        //this.ThreeColumns=true;
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-3-1-1-2':
        //this.ThreeColumns=true;
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-3-1-2-1':
        //this.ThreeColumns=true;
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-3-2-1-1':
        //this.ThreeColumns=true;
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-42':
        //this.FourColumns=true;
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-421':
        //this.FourColumns=true;
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-51':
        //this.FiveColumns=true;
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-632':
        //this.SixColumns=true;
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      default:
        //this.OneColumn=true;
        this._className = 'padding-25';
        this.text =
          ' <p>You can select the text and have optional elements like bold, italic, underline.  If you want to increase the size you can click on the h1, h2, and h3 tags.</p>';
    }
  }

  // If they choose the dropdown.
  setNewVariablesToDefault(): void {
    switch (this.rowType) {
      case 'col-2':
        // this.TwoColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        // this.text = '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-21':
        // this.TwoColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-2-1-2':
        // this.TwoColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-2-1-3':
        // this.TwoColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-2-2-1':
        // this.TwoColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-2-3-1':
        // this.TwoColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-31':
        // this.ThreeColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-3-1-1-2':
        // this.ThreeColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-3-1-2-1':
        // this.ThreeColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        //this.className = 'height-250 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-3-2-1-1':
        // this.ThreeColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-42':
        // this.FourColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-421':
        // this.FourColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text =
          '<p>You can select the text and have optional elements like bold, italix, underline, hyper link by selecting text. Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-51':
        // this.FiveColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        this._className = 'height-200 padding-25';
        this.text = '<p>Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      case 'col-632':
        // this.SixColumns=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        // this.className = 'height-200 padding-25';
        this._className = 'padding-25';
        this.text = '<p>Starting a new Line groups the h1, h2, and h3 respectively</p>';
        break;
      default:
        // this.OneColumn=true;
        this.flushed = '';
        this.color = '';
        this.background = '';
        this._className = 'padding-25';
        this.text =
          ' <p>You can select the text and have optional elements like bold, italic, underline.  If you want to increase the size you can click on the h1, h2, and h3 tags.</p>';
    }
  }

  // If they choose the Edit Component Link.
  setFormVariables(): void {
    this._typeOf = this._temp[this.compArray].typeOf
      ? this._temp[this.compArray].typeOf
      : this._typeOf;
    this.text = this._temp[this.compArray].text ? this._temp[this.compArray].text : this.text;
    this.flushed = this._temp[this.compArray].flushed;
    this._className = this._temp[this.compArray].className;
    this.color = this._temp[this.compArray].color;
    this.background = this._temp[this.compArray].background;
  }
}
